import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskCmdbInsightConfigureRoute: InvariantJiraRoute = {
	name: 'servicedesk-cmdb-configure',
	path: '/jira/servicedesk/insight/configure',
};
